'use strict';

var positions = require('../positions'),

    graphic = {
        480:  {},
        576:  {},
        720:  {},
        1080: {}
    };


graphic[480][positions.leftTop] = {
    width: 200,
    height: 160,
    x: 60,
    y: 40
};

graphic[480][positions.rightTop] = {
    width: graphic[480][positions.leftTop].width,
    height: graphic[480][positions.leftTop].height,
    x: 460,
    y: 40
};

graphic[480][positions.rightBottom] = {
    width: graphic[480][positions.leftTop].width,
    height: graphic[480][positions.leftTop].height,
    x: 460,
    y: 296
};

graphic[480][positions.leftBottom] = {
    width: graphic[480][positions.leftTop].width,
    height: graphic[480][positions.leftTop].height,
    x: 60,
    y: 296
};

// same values
graphic[576]  = graphic[480];
graphic[720]  = graphic[480];
graphic[1080] = graphic[480];


module.exports = graphic;
